import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FormControlLabel, Radio, Typography, useMediaQuery, useTheme } from '@mui/material';

import { checkIconStyles, formControlLabelStyles } from './LanguageChoiceButton.styles';

interface LanguageChoiceButtonProps {
	label: string;
	value: string;
	selected: boolean;
}

export default function LanguageChoiceButton({ value, label, selected }: Readonly<LanguageChoiceButtonProps>) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const fontVariant = isSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook';

	return (
		<FormControlLabel
			data-testid={label}
			sx={formControlLabelStyles(selected)}
			control={
				<>
					{selected ? (
						<CheckCircleIcon sx={checkIconStyles} data-testid="icon_selected" aria-label="Selected" />
					) : null}
					<Radio value={value} disableTouchRipple sx={{ display: 'none' }}></Radio>
				</>
			}
			label={
				<Typography align="center" color="secondary.main" variant={fontVariant}>
					{label}
				</Typography>
			}
		/>
	);
}
